import { useEffect } from "react";
import { useLocation } from "react-router-dom";

let previousPath = null;
let currentPath = null;

export const getPreviousPath = () => previousPath;

export const useRouteTrail = () => {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (path === currentPath) return;
    previousPath = currentPath;
    currentPath = path;
  }, [location.pathname, location.search]);
};
